import { Box, Stack, Typography } from '@mui/material';

import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/main/logo.webp';
import chevronRight from '../../../assets/svg/main/chevron-right.svg';
import { useAppState } from '../../../providers/AppProvider.hooks';
import { AppRoutes } from '../../../utils/constants';
import { resolveUserCredentials } from '../../../utils/credentials';
import Loader from '../../Loader';

function Header() {
  const navigate = useNavigate();
  const { isUserAuthorized } = useAppState();
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  const loginCredentials = useMemo(() => {
    return resolveUserCredentials(
      new URLSearchParams(window.location.search).get('creds'),
    );
  }, []);

  const moveToSignIn = () => {
    if (loginCredentials !== null && !isUserAuthorized) {
      setIsAuthenticating(true);
      return;
    }

    if (isUserAuthorized) {
      setIsAuthenticating(false);
      navigate(AppRoutes.DASHBOARD);

      return;
    }

    if (!isUserAuthorized) {
      setIsAuthenticating(false);
      navigate(AppRoutes.SIGN_IN);

      return;
    }
  };

  const moveToAskForRefund = () => {
    window.location.href = 'https://form.typeform.com/to/p1hg9p9g';
  };

  if (isAuthenticating) {
    return <Loader />;
  }

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '5px',
        width: '100%',
        padding: '22px 20px',
        position: 'relative',
        zIndex: 3,
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <img width={40} height={40} src={logo} alt="logo" />
        <Typography
          sx={{
            fontFamily: 'Avenir Next',
            fontWeight: 600,
            fontSize: '14px',
            color: '#1A1C23',
          }}
        >
          Metrics
          <br />
          Check
        </Typography>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '5px',
          flex: 1,
          justifyContent: 'flex-end',
        }}
      >
        <button
          style={{
            cursor: 'pointer',
            background: '#fff',
            fontSize: '14px',
            color: '#232631',
            fontWeight: 600,
            fontFamily: 'Avenir Next',
            textTransform: 'none',
            height: '36px',
            width: '100%',
            borderRadius: '8px',
            border: 'none',
            padding: '0 12px',
            WebkitTapHighlightColor: 'transparent',
            maxWidth: '116px',
          }}
          onClick={moveToAskForRefund}
        >
          Ask for refund
        </button>
        <button
          style={{
            cursor: 'pointer',
            background: '#256BFD',
            fontSize: '14px',
            color: '#fff',
            fontWeight: 600,
            fontFamily: 'Avenir Next',
            textTransform: 'none',
            height: '36px',
            width: '100%',
            borderRadius: '8px',
            border: 'none',
            padding: '0 12px',
            WebkitTapHighlightColor: 'transparent',
            alignItems: 'center',
            gap: '5px',
            display: 'flex',
            maxWidth: '80px',
          }}
          onClick={moveToSignIn}
        >
          Sign in
          <img width={6} height={10} src={chevronRight} alt="Chevron right" />
        </button>
      </Box>
    </Stack>
  );
}

export default Header;
